import React from 'react'
import { useIntl } from 'react-intl'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'LuxKit/Typography/BodyText'
import { useOrderTravellers } from 'tripPlanner/hooks/api/order'

type Props = {
  orderId: string
}

function OrderTravellers(props: Props) {
  const intl = useIntl()
  const { data: orderTravellers, status: loadingTravellerStatus } =
    useOrderTravellers(props.orderId)

  return (
    <>
      {loadingTravellerStatus === 'loading' && <LoadingIndicator inline />}
      {loadingTravellerStatus === 'success' &&
        orderTravellers.map((traveller, index) => (
          <div key={traveller.traveller_id}>
            <BodyText variant="medium" weight="bold">
              {intl.formatMessage(
                {
                  id: 'ljuLLPEAETKcEoctTJhR',
                  defaultMessage: 'Traveller {travellerNumber}',
                  description: 'Form field label for individual traveller in order details',
                },
                { travellerNumber: index + 1 },
              )}
            </BodyText>
            <BodyText variant="large">
              {intl.formatMessage(
                {
                  id: 'E2l3LC4WO4NGoCx-YIV2',
                  defaultMessage: '{firstName} {lastName}',
                  description: 'Full name display for a traveller in the booking confirmation or order summary',
                },
                {
                  firstName: traveller.first_name,
                  lastName: traveller.last_name,
                },
              )}
            </BodyText>
            <BodyText variant="medium" colour="neutral-two">
              {traveller.booking_number}
            </BodyText>
          </div>
        ))}
    </>
  )
}

export default OrderTravellers
